export const CULTURES = ['cafeArabica', 'cafeConilon'] as const;

export type Culture = (typeof CULTURES)[number];

export const CULTURE_LABELS: Record<Culture, string> = {
	cafeArabica: 'Café Arábica',
	cafeConilon: 'Café Conilon',
};

export const CULTURE_DESCRIPTIONS: Record<Culture, string> = {
	cafeArabica:
		'Coffea arabica - Café de altitude, sabor mais suave e aromático',
	cafeConilon:
		'Coffea canephora - Café mais resistente, maior teor de cafeína',
};
